/**
 * Utility functions for converting between HTML and plain text
 * Used primarily for TipTap editor content manipulation
 */

import { escapeHTMLPreserveFormatting } from "./escapeHtml"

/**
 * Converts HTML to plain text by removing paragraph tags and unescaping HTML entities
 * @param html - The HTML string to convert
 * @returns Plain text representation
 */
export const htmlToText = (html: string): string => {
  return html
    // Remove comment highlight spans (keep inner content)
    .replace(/<span[^>]*data-comment-id[^>]*>(.*?)<\/span>/g, "$1")
    .replace(/<span[^>]*class="comment-highlight"[^>]*>(.*?)<\/span>/g, "$1")
    .replace(/<p>/g, "")
    .replace(/<\/p>/g, "\n")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&nbsp;/g, " ")
    .replace(/<br\s*\/?>/g, "\n")
}

/**
 * Converts plain text to HTML by wrapping lines in paragraph tags and escaping special characters
 * Preserves formatting tags like <b>, <i>, <strong>, <em>, <u>
 * @param text - The plain text to convert
 * @returns HTML representation
 */
export const textToHtml = (text: string): string => {
  return text
    .split("\n")
    .map((line) => {
      const escaped = escapeHTMLPreserveFormatting(line)
      return `<p>${escaped}</p>`
    })
    .join("")
}
